/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../../../graphql.generated'

const defaultOptions = {} as const
export type ScheduleVideoCallByCareCoordinatorMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  callInput: Types.ScheduleVideoCallByCareCoordinatorInput
  acceptedConsentIDs?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>
}>

export type ScheduleVideoCallByCareCoordinatorMutation = {
  __typename?: 'Mutation'
  registerOnboardingPatient: { __typename: 'OnboardingPatient' }
  scheduleVideoCallByCareCoordinator: { __typename: 'VideoCall' }
}

export const ScheduleVideoCallByCareCoordinatorDocument = gql`
  mutation ScheduleVideoCallByCareCoordinator(
    $uid: ID!
    $callInput: ScheduleVideoCallByCareCoordinatorInput!
    $acceptedConsentIDs: [String!]
  ) {
    registerOnboardingPatient(input: { uid: $uid, acceptedConsentIDs: $acceptedConsentIDs }) {
      __typename
    }
    scheduleVideoCallByCareCoordinator(uid: $uid, callInput: $callInput) {
      __typename
    }
  }
`
export type ScheduleVideoCallByCareCoordinatorMutationFn = Apollo.MutationFunction<
  ScheduleVideoCallByCareCoordinatorMutation,
  ScheduleVideoCallByCareCoordinatorMutationVariables
>

/**
 * __useScheduleVideoCallByCareCoordinatorMutation__
 *
 * To run a mutation, you first call `useScheduleVideoCallByCareCoordinatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleVideoCallByCareCoordinatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleVideoCallByCareCoordinatorMutation, { data, loading, error }] = useScheduleVideoCallByCareCoordinatorMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      callInput: // value for 'callInput'
 *      acceptedConsentIDs: // value for 'acceptedConsentIDs'
 *   },
 * });
 */
export function useScheduleVideoCallByCareCoordinatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ScheduleVideoCallByCareCoordinatorMutation,
    ScheduleVideoCallByCareCoordinatorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ScheduleVideoCallByCareCoordinatorMutation,
    ScheduleVideoCallByCareCoordinatorMutationVariables
  >(ScheduleVideoCallByCareCoordinatorDocument, options)
}
export type ScheduleVideoCallByCareCoordinatorMutationHookResult = ReturnType<
  typeof useScheduleVideoCallByCareCoordinatorMutation
>
export type ScheduleVideoCallByCareCoordinatorMutationResult =
  Apollo.MutationResult<ScheduleVideoCallByCareCoordinatorMutation>
export type ScheduleVideoCallByCareCoordinatorMutationOptions = Apollo.BaseMutationOptions<
  ScheduleVideoCallByCareCoordinatorMutation,
  ScheduleVideoCallByCareCoordinatorMutationVariables
>
